import { mdiBulletinBoard } from '@mdi/js'

export default [
  {
    title: 'Logs.Menu',
    icon: mdiBulletinBoard,
    action: 'can_see_menu_log',
    resource: 'all',
    children: [
      {
        title: 'لاگ api',
        to: 'log-api',
        action: 'can_see_log_api',
        resource: 'all',
      },
      {
        title: 'لاگ سیستم',
        to: 'log-audit',
        action: 'can_see_log_audit',
        resource: 'all',
      },
      {
        title: 'لاگ فاکتور',
        to: 'log-bills',
        action: 'can_see_log_bills',
        resource: 'all',
      },
    ],
  },
]
